var _defs, _g, _g2, _g3, _g4, _g5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _g6, _g7, _g8, _g9, _g10, _g11, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiableRouge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_11",
    "data-name": "Calque 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 930.05 1288.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#88051b;}.cls-4{fill:#f2274a;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#070709;}.cls-7{fill:#1f201b;}.cls-8{fill:#545454;}.cls-9{fill:#85806b;}.cls-10{fill:#605c47;}.cls-11{fill:#1f170e;}.cls-12{clip-path:url(#clip-path-3);}.cls-13{clip-path:url(#clip-path-4);}.cls-14{clip-path:url(#clip-path-5);}.cls-15{fill:#969696;}.cls-16{fill:#565656;}.cls-17{fill:#a0a0a0;}.cls-18{fill:#55519e;}.cls-19{clip-path:url(#clip-path-6);}.cls-20{fill:#056aa5;}.cls-21{fill:#fb0f2a;}.cls-22{fill:#56829c;}.cls-23{fill:#094c7c;}.cls-24{clip-path:url(#clip-path-7);}.cls-25{clip-path:url(#clip-path-8);}.cls-26{clip-path:url(#clip-path-9);}.cls-27{clip-path:url(#clip-path-10);}.cls-28{clip-path:url(#clip-path-11);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1016,1047.42c-5.72,9.46-78.21,93.63-78.21,93.63-14.42,5.15-3.82,51.07,17.17,47.29l132.58,8.51,128.77,57.69c27.07,6.26,42-16.08,14.3-49.18l-79.16-121-50.56-143.76c-6.67-22.7-40-31.92-44.83-9.46C1056.1,931.09,1021.77,1038,1016,1047.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1200.71,
    cy: 1247.96,
    rx: 101.17,
    ry: 115.85,
    transform: "translate(-475.63 813.23) rotate(-31.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1056.63,
    cy: 957.61,
    rx: 99.83,
    ry: 115.33,
    transform: "translate(-328.2 617.44) rotate(-28.38)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 931.15,
    cy: 1179.12,
    rx: 96.68,
    ry: 112.06,
    transform: "translate(-438.56 561.65) rotate(-27.44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M967.4,1083.36c-5.73,9.46-78.22,93.63-78.22,93.63-14.42,5.15-3.81,51.07,17.17,47.29l132.58,8.51,128.77,57.69c27.08,6.25,42-16.08,14.31-49.18l-79.17-121-50.55-143.76c-6.68-22.7-40-31.92-44.83-9.46C1007.46,967,973.12,1073.9,967.4,1083.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1341,1051c.21-20.62-4.86-31.13-16-30l-50,35-10-459c1.46.09,2,0,3-2a41.37,41.37,0,0,0,0-14c-1.81-2.78-4.67-4.6-8-6l-7-191c-5.23-50.74-27.18-77.83-71-74l-106,36c-30.23,13.65-45,46-54,79l-52-28c-16.5-19.39-42,41-18,37l4,2c15.54,28.06,33.67,51.36,62,56l2,62-51,46-72-27c-1-6.31-5.08-9.23-13-8L695,490c-.87-2.83-3.84-3.91-8-4q-15,10.53-20,33l2,48c.72,8.63,4.51,16.15,13,22l84,30c9,4,14,4,25,2l77-16c3.72,6,8.86,8.13,16,5l138,58v6c-6.4,0-6.4,22,0,22l3,108L832,969c-24.32,23.66-33.17,57.52-32,98l27,183,13,36,165-115,3,3c2.06,31.43,11.42,59.89,34,83l1,5-38,23c-4.83,6.1-11.78,13.21-13,21l9,209s8,10,15,8,31-21,31-21l3,4v19c-5,2.23-8.77,7.26-11,13v26l-5,9,49,20,209-190c5.23-2.88,8.44-10.86,10-23l10-100,24-18c8.07-5.56,10-12,10-21ZM1016,473c-12.17-3.84-16.29-9.2-18-15l18,9ZM789,606a56.49,56.49,0,0,1-20-2l-84-30c-4.47-1.91-8.07-4.46-9-9l-2-31s1-5,5-3,155,60,155,61S789,606,789,606Zm223,326-5,215L841,1257l-3-219c.42-19.21,7-32.33,18-41l161-129c1.13,3,3.07,4.43,6,4C1014.5,884.49,1012.12,906.48,1012,932Zm79-551,105-37c13.31-2.05,18.18,21.9,23,46v75l-40,43-45-23c-2-9-7.74-11.83-15-10l-59-30C1066.33,409.82,1077.32,390.75,1091,381Zm-33,108,29,16c-6.07,2.69-17.77-4.56-29-11Zm2,26,5,3c-.53,1.44,9.84,3.39,14,2,3-1,23-6,23-6,4.4,4.31,9.15,3.93,14,2l74,42c-46.68,20-100,50-127,55Zm12,179,2-2V679c-2-3-2.16-4.78-8-7v-7c51.42-31.33,101.8-57.25,151-77v8l2,2,3,95-45,43,7-19c-4-5.16-9.78-5.23-16-4l-2,30-24,14,3-18c-3-3.81-9-3.93-16-3v28l-53,30Zm27,722-5-126,16,8Zm45-263c-7.79.92-15.39,26.21-23,51l-8,57-22-9-13-393,96-76,48-29,9,335Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700,1252c-6,10-82,99-82,99-15.12,5.44-4,54,18,50l139,9,135,61c28.39,6.61,44-17,15-52l-83-128-53-152c-7-24-42-33.75-47-10C742,1129,706,1242,700,1252Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 893.6,
    cy: 1464.04,
    rx: 106.3,
    ry: 122.22,
    transform: "translate(-612.3 642.95) rotate(-30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 742.56,
    cy: 1157.04,
    rx: 104.85,
    ry: 121.73,
    transform: "translate(-444.47 463.42) rotate(-27.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 611,
    cy: 1391.25,
    rx: 101.53,
    ry: 118.29,
    transform: "translate(-550.13 411.11) rotate(-26.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(-487.95 -309.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649,1290c-6,10-82,99-82,99-15.12,5.44-4,54,18,50l139,9,135,61c28.39,6.61,44-17,15-52l-83-128-53-152c-7-24-42-33.75-47-10C691,1167,655,1280,649,1290Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "diable bleu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1016,1047.42c-5.72,9.46-78.21,93.63-78.21,93.63-14.42,5.15-3.82,51.07,17.17,47.29l132.58,8.51,128.77,57.69c27.07,6.26,42-16.08,14.3-49.18l-79.16-121-50.56-143.76c-6.67-22.7-40-31.92-44.83-9.46C1056.1,931.09,1021.77,1038,1016,1047.42Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1014.13,1048.37c-5.72,9.46-78.21,93.63-78.21,93.63-14.42,5.14-3.81,51.07,17.17,47.29l132.58,8.51,128.77,57.69c27.07,6.25,42-16.08,14.31-49.18l-79.17-121.06L1099,941.5c-6.68-22.7-40-31.92-44.83-9.46C1054.2,932,1019.86,1038.91,1014.13,1048.37Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1201.14,
    cy: 1248.12,
    rx: 101.17,
    ry: 115.85,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -963.6, 503.85)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1182.58,
    cy: 1263.11,
    rx: 101.17,
    ry: 115.85,
    transform: "translate(-974.2 496.35) rotate(-31.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1183,1174.15l18.18-18.13,36.67-7.47,30,6.69,46.74,67.15-8.8,25.73H1284.6l-26.29-.2C1242.59,1212.49,1218.46,1186.76,1183,1174.15Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1183.06,
    cy: 1258.74,
    rx: 60.43,
    ry: 75.18,
    transform: "translate(-967.12 478.93) rotate(-30.98)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1184.86,
    cy: 1259.31,
    rx: 49.84,
    ry: 63.24,
    transform: "translate(-966.5 477.65) rotate(-30.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1187.73,1287.64l28.62-29.31c9.53-13.25-15.27-38.78-28.62-29.32l-10.49,9.45Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1057.06,
    cy: 957.77,
    rx: 99.83,
    ry: 115.33,
    transform: "translate(-816.18 308.02) rotate(-28.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1038.83,
    cy: 972.77,
    rx: 99.83,
    ry: 115.33,
    transform: "translate(-825.5 301.16) rotate(-28.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1039.2,883.81l17.86-18.13,36-7.47,29.51,6.68L1168.5,932l-8.64,25.73H1139l-25.82-.19C1097.78,922.14,1074.08,896.41,1039.2,883.81Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1039.3,
    cy: 968.4,
    rx: 59.63,
    ry: 74.85,
    transform: "translate(-826.91 314.77) rotate(-28.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1041.07,
    cy: 968.96,
    rx: 49.18,
    ry: 62.96,
    transform: "translate(-827.44 317.62) rotate(-29.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1043.89,997.3,1072,968c9.37-13.24-15-38.78-28.11-29.32l-10.31,9.46Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 931.57,
    cy: 1179.28,
    rx: 96.68,
    ry: 112.06,
    transform: "translate(-926.53 252.22) rotate(-27.44)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 913.93,
    cy: 1193.86,
    rx: 96.68,
    ry: 112.06,
    transform: "translate(-935.23 245.73) rotate(-27.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M914.29,1107.32l17.28-17.64,34.83-7.27,28.55,6.51,44.41,65.32-8.36,25h-20.14l-25-.19C971,1144.61,948,1119.58,914.29,1107.32Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 914.38,
    cy: 1189.61,
    rx: 57.75,
    ry: 72.72,
    transform: "translate(-943.09 267.04) rotate(-28.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 916.09,
    cy: 1190.16,
    rx: 47.63,
    ry: 61.17,
    transform: "translate(-944.49 270.94) rotate(-28.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M918.82,1217.73,946,1189.21c9.06-12.88-14.5-37.73-27.19-28.53l-10,9.21Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M967.4,1083.36c-5.73,9.46-78.22,93.63-78.22,93.63-14.42,5.15-3.81,51.07,17.17,47.29l132.58,8.51,128.77,57.69c27.08,6.25,42-16.08,14.31-49.18l-79.17-121-50.55-143.76c-6.68-22.7-40-31.92-44.83-9.46C1007.46,967,973.12,1073.9,967.4,1083.36Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M965.49,1084.31c-5.72,9.45-78.21,93.63-78.21,93.63-14.43,5.14-3.82,51.07,17.16,47.28l132.59,8.52,128.76,57.69c27.08,6.25,42-16.08,14.31-49.18l-79.17-121.06-50.55-143.75c-6.68-22.7-40-31.92-44.83-9.46C1005.55,968,971.21,1074.85,965.49,1084.31Z",
    transform: "translate(-487.95 -309.64)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1032.12,
    cy: 1148.92,
    rx: 21.56,
    ry: 29.02,
    transform: "translate(-895 278.86) rotate(-26.79)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1031.3,
    cy: 1151.45,
    rx: 18.74,
    ry: 22.02,
    transform: "translate(-901.46 292.33) rotate(-27.33)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1028.83,
    cy: 1152.69,
    rx: 17.25,
    ry: 22.02,
    transform: "translate(-898.41 281.24) rotate(-26.93)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1029.13,
    cy: 1154.04,
    rx: 9.49,
    ry: 11.15,
    transform: "translate(-902.89 291.62) rotate(-27.33)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1025.02,
    cy: 1155.61,
    rx: 8.74,
    ry: 11.15,
    transform: "translate(-900.14 279.83) rotate(-26.93)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1024.43,
    cy: 1156.26,
    rx: 6.18,
    ry: 8.92,
    transform: "translate(-897.93 273.17) rotate(-26.67)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1341,1051c.21-20.62-4.86-31.13-16-30l-50,35-10-459c1.46.09,2,0,3-2a41.37,41.37,0,0,0,0-14c-1.81-2.78-4.67-4.6-8-6l-7-191c-5.23-50.74-27.18-77.83-71-74l-106,36c-30.23,13.65-45,46-54,79l-52-28c-16.5-19.39-42,41-18,37l4,2c15.54,28.06,33.67,51.36,62,56l2,62-51,46-72-27c-1-6.31-5.08-9.23-13-8L695,490c-.87-2.83-3.84-3.91-8-4q-15,10.53-20,33l2,48c.72,8.63,4.51,16.15,13,22l84,30c9,4,14,4,25,2l77-16c3.72,6,8.86,8.13,16,5l138,58v6c-6.4,0-6.4,22,0,22l3,108L832,969c-24.32,23.66-33.17,57.52-32,98l27,183,13,36,165-115,3,3c2.06,31.43,11.42,59.89,34,83l1,5-38,23c-4.83,6.1-11.78,13.21-13,21l9,209s8,10,15,8,31-21,31-21l3,4v19c-5,2.23-8.77,7.26-11,13v26l-5,9,49,20,209-190c5.23-2.88,8.44-10.86,10-23l10-100,24-18c8.07-5.56,10-12,10-21ZM1016,473c-12.17-3.84-16.29-9.2-18-15l18,9ZM789,606a56.49,56.49,0,0,1-20-2l-84-30c-4.47-1.91-8.07-4.46-9-9l-2-31s1-5,5-3,155,60,155,61S789,606,789,606Zm223,326-5,215L841,1257l-3-219c.42-19.21,7-32.33,18-41l161-129c1.13,3,3.07,4.43,6,4C1014.5,884.49,1012.12,906.48,1012,932Zm79-551,105-37c13.31-2.05,18.18,21.9,23,46v75l-40,43-45-23c-2-9-7.74-11.83-15-10l-59-30C1066.33,409.82,1077.32,390.75,1091,381Zm-33,108,29,16c-6.07,2.69-17.77-4.56-29-11Zm2,26,5,3c-.53,1.44,9.84,3.39,14,2,3-1,23-6,23-6,4.4,4.31,9.15,3.93,14,2l74,42c-46.68,20-100,50-127,55Zm12,179,2-2V679c-2-3-2.16-4.78-8-7v-7c51.42-31.33,101.8-57.25,151-77v8l2,2,3,95-45,43,7-19c-4-5.16-9.78-5.23-16-4l-2,30-24,14,3-18c-3-3.81-9-3.93-16-3v28l-53,30Zm27,722-5-126,16,8Zm45-263c-7.79.92-15.39,26.21-23,51l-8,57-22-9-13-393,96-76,48-29,9,335Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M884,610c-10-3.52,3-40.52,13-37l11-14L674,464l-21,67s24,87,21,88,175,41,175,41Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1018,492l-1-26c1.11-19.38,2.49-35.92,5-40v-8l-73-34s-20,13-20,19,6,33,6,33l8,23,66,47Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1060,515l6,9,50-3v-5c-16.08-9.33,2-46,18-31l8-8-76-37-6,5C1057.56,456.89,1058.58,485,1060,515Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1089,1593l34-351c6.52-41.24,14.43-78.63,31-92l173-123c6.41-4.29,10,.88,12.8,8.54L1418,1211l-52,154s-66,167-74,171S1089,1593,1089,1593Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1078,859V839l135.71-80S1101,865,1099,866,1078,859,1078,859Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "691.05 198.36 726.05 214.36 734.05 206.36 731.05 156.36 691.05 198.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "535.05 308.36 534.05 244.36 502.05 296.36 535.05 308.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M791,1043c16,18,58,72,58,72l167-247,12,9,15,384-160,48-56-5Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "602.98 940.06 606.13 982.46 622.05 988.36 625.61 947.36 602.98 940.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "559.05 1192.36 606.05 1159.36 590.05 1274.36 544.05 1250.36 559.05 1192.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "734.05 444.36 750.05 436.36 758.05 767.36 734.05 785.98 734.05 444.36"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M700,1252c-6,10-82,99-82,99-15.12,5.44-4,54,18,50l139,9,135,61c28.39,6.61,44-17,15-52l-83-128-53-152c-7-24-42-33.75-47-10C742,1129,706,1242,700,1252Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M698,1253c-6,10-82,99-82,99-15.12,5.44-4,54,18,50l139,9,135,61c28.39,6.61,44-17,15-52l-83-128-53-152c-7-24-42-33.75-47-10C740,1130,704,1243,698,1253Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 894.06,
    cy: 1464.21,
    rx: 106.3,
    ry: 122.22,
    transform: "translate(-1100.27 333.56) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 874.6,
    cy: 1480.06,
    rx: 106.3,
    ry: 122.22,
    transform: "translate(-1110.8 325.95) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M875,1386l19.06-19.17,38.44-7.9L964,1366l49,71-9.22,27.21H981.56L954,1464C937.52,1426.53,912.22,1399.33,875,1386Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 875.1,
    cy: 1475.44,
    rx: 63.5,
    ry: 79.32,
    transform: "translate(-1108.43 325.58) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 876.99,
    cy: 1476.04,
    rx: 52.36,
    ry: 66.72,
    transform: "translate(-1108.47 326.6) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880,1506l30-31c10-14-16-41-30-31l-11,10Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 743.01,
    cy: 1157.21,
    rx: 104.85,
    ry: 121.73,
    transform: "translate(-932.44 154.01) rotate(-27.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 723.89,
    cy: 1173.06,
    rx: 104.85,
    ry: 121.73,
    transform: "translate(-941.73 147.05) rotate(-27.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M724.28,1079,743,1059.83l37.76-7.9,30.94,7.07,48.13,71-9.06,27.21H829l-27.07-.21C785.7,1119.53,760.85,1092.33,724.28,1079Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 724.38,
    cy: 1168.44,
    rx: 62.64,
    ry: 78.99,
    transform: "matrix(0.88, -0.47, 0.47, 0.88, -952.42, 168.42)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 726.24,
    cy: 1169.04,
    rx: 51.66,
    ry: 66.44,
    transform: "translate(-954.24 172.42) rotate(-28.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M729.19,1199l29.47-31c9.83-14-15.71-41-29.47-31L704,1160Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 611.43,
    cy: 1391.42,
    rx: 101.53,
    ry: 118.29,
    transform: "translate(-1038.11 101.68) rotate(-26.12)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 592.95,
    cy: 1406.84,
    rx: 101.53,
    ry: 118.29,
    transform: "translate(-1046.79 95.12) rotate(-26.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M593.32,1315.33l18.11-18.65L648,1289l29.93,6.88L724.44,1365l-8.76,26.47H694.57l-26.19-.2C652.73,1354.76,628.69,1328.3,593.32,1315.33Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 593.42,
    cy: 1402.35,
    rx: 60.66,
    ry: 76.75,
    transform: "translate(-1067.78 122.03) rotate(-27.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 595.21,
    cy: 1402.93,
    rx: 50.03,
    ry: 64.55,
    transform: "translate(-1071.04 126.81) rotate(-27.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M598.07,1432.08l28.51-30.16c9.5-13.62-15.2-39.89-28.51-30.16l-10.45,9.73Z",
    transform: "translate(-487.95 -309.64)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M649,1290c-6,10-82,99-82,99-15.12,5.44-4,54,18,50l139,9,135,61c28.39,6.61,44-17,15-52l-83-128-53-152c-7-24-42-33.75-47-10C691,1167,655,1280,649,1290Z",
    transform: "translate(-487.95 -309.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M647,1291c-6,10-82,99-82,99-15.12,5.44-4,54,18,50l139,9,135,61c28.39,6.61,44-17,15-52l-83-128-53-152c-7-24-42-33.75-47-10C689,1168,653,1281,647,1291Z",
    transform: "translate(-487.95 -309.64)"
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 716.86,
    cy: 1359.32,
    rx: 22.65,
    ry: 30.63,
    transform: "translate(-1013.21 144.82) rotate(-26.12)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 716,
    cy: 1362,
    rx: 19.68,
    ry: 23.24,
    transform: "translate(-1014.48 144.71) rotate(-26.12)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 713.41,
    cy: 1363.31,
    rx: 18.12,
    ry: 23.24,
    transform: "translate(-1015.32 143.71) rotate(-26.12)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 713.73,
    cy: 1364.73,
    rx: 9.97,
    ry: 11.77,
    transform: "translate(-1015.91 143.99) rotate(-26.12)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 709.41,
    cy: 1366.39,
    rx: 9.18,
    ry: 11.77,
    transform: "translate(-1017.09 142.26) rotate(-26.12)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 708.79,
    cy: 1367.08,
    rx: 6.49,
    ry: 9.42,
    transform: "translate(-1017.45 142.06) rotate(-26.12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiableRouge);
export default __webpack_public_path__ + "static/media/diable_rouge.1245cd9aced97befc4d16f0fd2f983f5.svg";
export { ForwardRef as ReactComponent };